import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Start = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleGetStarted = async () => {
    setIsLoading(true);
    
    try {
      // Fetch the next link in rotation (7K signup link)
      const response = await axios.get(`${API}/join-links/next-rotation`);
      const joinLink = response.data.join_now_link;
      
      // Navigate to the affiliate link directly (works on all devices including iOS)
      window.location.href = joinLink;
    } catch (error) {
      console.error('Error fetching join link:', error);
      setIsLoading(false);
      // Stay on the start page if there's an error
      alert('Unable to load signup link. Please try again.');
    }
  };

  return (
    <div className="start-page">
      <div className="start-container">
        <div className="start-content">
          <img src="/epg_logo.png" alt="Electrum Prosperity Group" className="start-logo" />
          
          <h2 className="start-headline">
            Secure Your Wealth,
            <br />
            Shape Your Future
            <br />
            With Electrum Prosperity Group.
          </h2>
          
          <p className="start-description">
            Build lasting wealth through proven strategies. Expert guidance for financial freedom. 
            Join thousands who've transformed their financial future.
          </p>
          
          <Button className="start-cta" onClick={handleGetStarted} disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 size={24} className="animate-spin" />
                Loading...
              </>
            ) : (
              <>
                Sign Up
                <ArrowRight size={24} className="cta-arrow" />
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Start;
